const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Track First Load Point',
  description: 'Reached loading point for non docks (gates without docks) Truck in > Reached loading point',
  sortOrder: 1,
  name: 'track_first_load_point',
  documentKey: 'track_first_load_point',
  values: {
    track_first_load_point: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'Track First Load Point',
      documentKey: 'track_first_load_point',
    },
  },
};
